import React, { useState } from "react";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils"
import Handler from "../../Helpers/Components/Handler"
import { useNavigate } from "react-router-dom";

const Add = () => {
    const [subadmin, setSubadmin] = useState({})
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const validPhoneNumber = new RegExp('^[6-9]{1}[0-9]{9}');
    const validEmail = new RegExp('([a-z0-9.]{2,})+@([a-z]{3,})+([.]{1})+[a-z]{2,3}')
    const [disable, setDisable] = useState(false)
    const navigate = useNavigate()
    const handleChange = (e) => {
        setSubadmin((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const handleSubmit = async () => {
        if (!(subadmin?.name)) {
            toast.error("Name is required");
        } else if ((!validName.test(subadmin?.name))) {
            toast.error("Invalid Name");
        } else if (!(subadmin?.password)) {
            toast.error("Password is required");
        } else if (!(subadmin?.phone)) {
            toast.error("phone Number is required");
        } else if (!validPhoneNumber.test(subadmin?.phone)) {
            toast.error("phone Number is Invalid");
        } else if (!(subadmin?.email)) {
            toast.error("Email is required");
        } else if (!validEmail.test(subadmin?.email)) {
            toast.error("Email is Invalid");
        } else {
            setDisable(true)
            const response = await Handler({ url: 'admin/subadmin/signup', data: subadmin, method: 'post' })
            if (response?.success) {
                toast.success(response?.message);
                setTimeout(() => {
                    reloadWindowToPath("/subadmin/1");
                }, 1000);
            } else {
                setDisable(false)
                toast.error(response?.message)
            }
        }
    }
    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            <h5 className="text-center text-theme fs-4">Subadmin Register</h5>
            <div className="layout-card mt-4 p-5">
                <div className="row mt-3">
                    <div className="col-lg-3">
                        <div className="form_title">Contact Info</div>
                    </div>
                    <div className="col-lg-9">
                        <div className="row">
                            <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label"> Name </label>
                                    <input autoComplete="off" disabled={disable} id="name" placeholder="Name" type="text" name="name" value={subadmin?.name || ""} onChange={handleChange} className="form-control input-theme text-uppercase" />
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label"> Password </label>
                                    <input autoComplete="off" disabled={disable} placeholder="Password" id="password" type="text" name="password" value={subadmin?.password || ""} onChange={handleChange} className="form-control input-theme text-uppercase" />
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                <div className="mb-3">
                                    <label htmlFor="phone" className="form-label"> Phone </label>
                                    <input maxLength={10} disabled={disable} placeholder="Phone" autoComplete="off" id="phone" type="text" name="phone" value={subadmin?.phone || ""} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} className="form-control input-theme text-uppercase" />
                                </div>
                            </div>
                            <div className="my-3 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                <label htmlFor="email" className="mb-1">Email</label>
                                <input disabled={disable} autoComplete="off" id="email" name="email" className="form-control input-theme" placeholder="Email" value={subadmin?.email || ""} onChange={handleChange} type="text" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center mt-3"><button className="btn btn-theme" disabled={disable} onClick={handleSubmit}>{disable ? <i className="fa-solid fa-spinner fa-spin"></i> : "Register"}</button></div>
            </div>
        </React.Fragment>
    )
}

export default Add;